import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { HeaderService } from '../../service/header.service';
import { ProfileDataService } from '../service/profile-data.service';

@Component({
  selector: 'app-alterar-dados-cadastrais',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './alterar-dados-cadastrais.component.html',
  styleUrls: ['./alterar-dados-cadastrais.component.scss'],
})
export class AlterarDadosCadastraisComponent implements OnInit {
  readonly BASE_IMG_URL: string = environment.BASE_IMG_URL;

  positions: Array<{ cargo: string; id: string }> = [
    { cargo: 'Diretor(a) Comercial', id: '1' },
    { cargo: 'Gerente Comercial', id: '2' },
    { cargo: 'Representante Comercial', id: '3' },
    { cargo: 'Assistente Comercial', id: '4' },
    { cargo: 'Vendedor(a)', id: '5' },
    { cargo: 'Proprietário(a)', id: '6' },
    { cargo: 'Outro(a)', id: '7' },
  ];

  position: string = '';
  fullName: string = '';
  phone: string = '';
  email: string = '';
  login: string = '';

  constructor(
    private router: Router,
    private headerService: HeaderService,
    private profileDataService: ProfileDataService,
  ) {}

  ngOnInit(): void {
    this.loadProfileData();
  }

  private loadProfileData(): void {
    this.profileDataService.loadProfileData().subscribe(
      (response: any) => {
        const profileData = this.profileDataService.getProfileData();
        if (profileData) {
          this.fullName = profileData.name;
          this.phone = this.applyPhoneMask(profileData.phone);
          this.email = profileData.email;
          this.login = profileData.login;

          const foundPosition = this.positions.find(
            (p) => p.id === profileData.occupation,
          );
          this.position = foundPosition ? foundPosition.cargo : '';
        }
      },
      (error) => {
        console.error('Erro ao carregar dados do perfil:', error);
      },
    );
  }

  private applyPhoneMask(phone: string): string {
    const numbers = phone.replace(/\D/g, '');

    if (numbers.length === 11) {
      return numbers.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }
    if (numbers.length === 10) {
      return numbers.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }

    return phone;
  }

  private validateForm(): boolean {
    if (!this.fullName.trim()) {
      Swal.fire({
        text: 'Por favor, preencha o nome completo.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      return false;
    }

    const phoneNumbers = this.phone.replace(/\D/g, '');
    if (!phoneNumbers) {
      Swal.fire({
        text: 'Por favor, preencha o telefone.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      return false;
    }
    if (phoneNumbers.length !== 11) {
      Swal.fire({
        text: 'Telefone inválido. Digite 11 dígitos (Ex: (11) 99999-9999).',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!this.email.trim()) {
      Swal.fire({
        text: 'Por favor, preencha o e-mail.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      return false;
    }
    if (!emailRegex.test(this.email)) {
      Swal.fire({
        text: 'E-mail inválido. Digite um e-mail válido.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      return false;
    }

    if (!this.position) {
      Swal.fire({
        text: 'Por favor, selecione um cargo.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      return false;
    }

    return true;
  }

  formatPhone(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');

    if (value.length > 11) {
      value = value.substring(0, 11);
    }

    if (value.length > 6) {
      value = value.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
    } else if (value.length > 2) {
      value = value.replace(/(\d{2})(\d{0,5})/, '($1) $2');
    } else if (value.length > 0) {
      value = value.replace(/(\d{0,2})/, '($1');
    }

    input.value = value;
    this.phone = value;
  }

  saveChanges(): void {
    if (!this.validateForm()) {
      return;
    }

    const selectedPosition = this.positions.find(
      (p) => p.cargo === this.position,
    );
    const occupationId = selectedPosition?.id || '';
    const phoneNumbers = this.phone.replace(/\D/g, '');

    const data = {
      name: this.fullName,
      phone: phoneNumbers,
      email: this.email,
      occupation: occupationId,
    };

    this.headerService.updateProfileData(data).subscribe(
      (response: any) => {
        if (response?.success) {
          Swal.fire({
            text: 'Dados atualizados com sucesso!',
            icon: 'success',
            confirmButtonText: 'OK',
          });
        } else {
          Swal.fire({
            text:
              response?.message || 'Erro ao atualizar dados. Tente novamente.',
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
      },
      (error) => {
        console.error('Erro ao atualizar dados do perfil:', error);
        Swal.fire({
          text:
            error?.error?.message ||
            'Erro ao atualizar dados. Tente novamente.',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      },
    );
  }

  goBackToProfile(): void {
    this.router.navigate(['/usuario']);
  }
}
